// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9031 ? "e89fb3a8" : chunkId) + "." + {"7999":"87d9fe860f9a2de2","8028":"4f9f37823c9d4489","9031":"c83c8b2f259e8dfe"}[chunkId] + ".js";
};